import { useLayoutEffect } from "react";

import chart from "./chart";
import Canvas from "./Canvas";

function Doughnut(props) {
  const { refName, height, width, dataSet, options } = props;

  useLayoutEffect(() => {
    const doughnut = chart({ type: "doughnut", ...props });

    return () => {
      doughnut.destroy();
    };
  }, [refName, dataSet, options]);

  return <Canvas name={refName} height={height} width={width} />;
}

export default Doughnut;
